import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {
  parseJSONWithBetterErrors,
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation, useQueryClient} from '@github-ui/react-query'
import {pullRequestMarkersKey, type Markers} from '../page-data/loaders/use-markers-data'

export type UnhideCommentMutationResponse = {
  commentDatabaseId: number
  threadId: number
}

/**
 * unhides a comment
 */
export function useUnhideCommentMutation(basePath: string) {
  const apiUrl = `${basePath}/page_data/${PageData.unhideComment}`
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({commentDatabaseId}: {commentDatabaseId: number}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          commentId: commentDatabaseId,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: UnhideCommentMutationResponse) => {
      return queryClient.setQueryData(pullRequestMarkersKey(basePath), (oldMarkersData: Markers) => {
        if (!oldMarkersData) return undefined
        const oldThread = oldMarkersData.threads[data.threadId]
        if (!oldThread) return undefined

        return {
          ...oldMarkersData,
          threads: {
            ...oldMarkersData.threads,
            [data.threadId]: {
              ...oldMarkersData.threads[data.threadId],
              commentsData: {
                ...oldMarkersData.threads[data.threadId]?.commentsData,
                comments: oldMarkersData.threads[data.threadId]?.commentsData.comments.map(comment => {
                  if (comment.databaseId === data.commentDatabaseId) {
                    return {
                      ...comment,
                      isHidden: false,
                      minimizedReason: null,
                    }
                  }
                  return comment
                }),
              },
            },
          },
        }
      })
    },
  })
}
